var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElevatorcomponent = function SvgElevatorcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M32 3.444C32 2.647 31.353 2 30.556 2H3.444C2.647 2 2 2.647 2 3.444v17.112C2 21.353 2.647 22 3.444 22h27.112c.797 0 1.444-.647 1.444-1.444zm2 17.112A3.444 3.444 0 0 1 30.556 24H3.444A3.444 3.444 0 0 1 0 20.556V3.444A3.444 3.444 0 0 1 3.444 0h27.112A3.444 3.444 0 0 1 34 3.444z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16 1h2v22h-2zm8 16V8a1 1 0 1 1 2 0v9a1 1 0 1 1-2 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M27.493 13.094a1 1 0 0 1 1.414 1.414l-3.2 3.2a1 1 0 0 1-1.414 0l-3.2-3.2a1 1 0 1 1 1.414-1.414L25 15.587zM10 7v9a1 1 0 1 1-2 0V7a1 1 0 0 1 2 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.493 10.906a1 1 0 0 0 1.414-1.414l-3.2-3.2a1 1 0 0 0-1.414 0l-3.2 3.2a1 1 0 1 0 1.414 1.414L9 8.413z"
  })));
};
export default SvgElevatorcomponent;